import { useMemo } from "react";
// MUI
import { Stack, Typography } from "@mui/material";
// Third party
import clsx from "clsx";

// Types
import { IConfiguredAccount } from "@/Settings/types/administrationTools/model";

// Helpers
import { getLocalDate } from "@/Common/helpers/Dates";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

interface IConfiguredAccountProps {
	providerName: string;
	account: IConfiguredAccount;
	timezone: string;
	onDelete: (providerName: string, displayId: string) => void;
}

const ConfiguredAccount = (props: IConfiguredAccountProps) => {
	const { providerName, account, onDelete, timezone } = props;
	const { displayId, status, statusDate } = account;

	const formattedDate = getLocalDate(statusDate, DATE_FORMAT.usDateTime12hPadded, timezone);

	const accountText = useMemo(() => {
		return status === "AWAITING"
			? `Awaiting access since ${formattedDate} for Company ID: ${displayId}`
			: `Authenticated Company ID ${formattedDate}: ${displayId}`;
	}, [status, formattedDate, displayId]);

	const couldBeDeleted = useMemo(() => {
		return status === "AWAITING";
	}, [status]);

	return (
		<Stack spacing={0.5} direction={"row"} alignItems={"center"} justifyContent={"flex-start"} height={"24px"}>
			<Typography className="!text-xs !font-sans !font-normal !text-default">{accountText}</Typography>
			{couldBeDeleted && (
				<CloseRoundedIcon
					fontSize="small"
					className={clsx({
						"!cursor-pointer !text-default": couldBeDeleted,
						"!cursor-default !text-disabled": !couldBeDeleted,
					})}
					onClick={() => {
						onDelete(providerName, displayId);
					}}
				/>
			)}
		</Stack>
	);
};

export default ConfiguredAccount;
